export { menuVariables as menuItemWrapperVariables } from './menuVariables';
